// Hotel-related utility helpers (Phase 2 Track 2H).
// `helipadType` is the structured replacement for the legacy `helipad`
// freetext field. After migration every hotel doc has helipadType set;
// missing values are treated as 'transfer' (editor must fill manually).

export function isDirectHelipad(h) {
  return h?.helipadType === 'direct';
}

export function helipadLabel(h) {
  return h?.helipadType === 'direct'
    ? 'Direct helipad on property'
    : 'Helicopter transfer available';
}
